export function top() {
  window.$scroller.scrollTo(0);
}

export function bottom() {
  window.$scroller.scrollTo(999999);
}
